/**
 * The only link schemes a filed document may open with. A document's `url`
 * is typed by an owner or director (and loaded from JSON by the loaders),
 * so it is data, not code: anything that is not a plain web address —
 * `javascript:`, `data:`, a bare path — renders as text, never as a link.
 * The server refuses such a url at write time as well (src/leases.js and
 * src/insurance.js); this is the client's half of the same guard.
 */
export function webLink(url: string | null | undefined): string | null {
  if (!url) return null;
  return /^https?:\/\//i.test(url.trim()) ? url.trim() : null;
}
